<template>
  <div :style="$vuetify.breakpoint.name !== 'xl' ? '' : 'min-height: 100vh;'">
    <div class="background-login" :style="$vuetify.breakpoint.name !== 'xl' ? 'min-height: 100vh;' : 'background-size: 100%; min-height: 100vh;'">
      <v-container class="pt-12 pb-0" :style="$vuetify.breakpoint.name !== 'xl' ? '' : 'padding-top: 3% !important;'">
        <v-row :class="$vuetify.breakpoint.name === 'lg' ? 'align-center':'align-center justify-center'">
          <v-col cols="12" :order="$vuetify.breakpoint.name === 'xl' ? 'last':'first'"
          :sm="$vuetify.breakpoint.name === 'xs' ? '12' : $vuetify.breakpoint.name === 'sm' ? '9' : $vuetify.breakpoint.name === 'xl' ? 12:6"
         >
            <v-card
              :height="$vuetify.breakpoint.name === 'xs' ? '100%' : $vuetify.breakpoint.name === 'sm' ? '100%' : '500'"
              :width="$vuetify.breakpoint.name === 'xs' ? '100%' : $vuetify.breakpoint.name === 'sm' ? '100%' : $vuetify.breakpoint.name === 'xl' ? '38%':'65%'"
              class="text-center pa-5 border-radius mx-auto pb-12 pt-8"
              :class="$vuetify.breakpoint.name === 'xs'?'pa-8 rounded-default':'pa-8 rounded-default'"
              style="padding-top: 50px !important;">
              <div class="d-flex justify-center align-center mb-3">
                <div class="headline font-weight-bold text--secondary mt-5 mb-5">
                  LOGIN
                </div>
              </div>
              <ValidationObserver ref="observer">
                <v-form class="text-left mb-10">
                  <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                    <v-text-field
                      v-on:keyup.enter="save"
                      outlined
                      dense
                      color="#FF618A"
                      type="email"
                      placeholder="email"
                      v-model="form.username"
                      :error-messages="errors"
                      required>
                    </v-text-field>
                  </ValidationProvider>
                  <ValidationProvider
                    name="Password"
                    rules="required|min:5|max:20"
                    v-slot="{ errors }">  
                    <v-text-field
                      v-on:keyup.enter="save"
                      class="mt-2 mb-1"
                      outlined
                      color="#FF618A"
                      dense
                      placeholder="Password"
                      v-model="form.password"
                      :type="show ? 'text' : 'password'"
                      :counter="20"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show = !show"
                      :error-messages="errors"
                      required>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>
              <div class="text-center mt-4">
                <v-alert type="error" text dense prominent v-show="response !== ''">{{ response }}</v-alert>
                <v-btn
                  rounded
                  block
                  small
                  color="#ff618a"
                  :disabled="process.run"
                  :loading="process.run"
                  @click="save"
                  class="white--text text-capitalize mt-7">
                  LOGIN
                </v-btn>
              </div>
              
            </v-card>
          </v-col>
          <v-col cols="12" :order="$vuetify.breakpoint.name === 'xl' ? 'first':'last'" sm="4" class="text-center hidden-sm-and-down">
            <img :src="require('../../assets/logo/logocendekia2.png')" width="300"/>
            <div class="caption mt-5 mb-2 white--text">
              Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-row class="container-login hidden-sm-and-down" align="end" style="margin-top:-100px;" v-if="$vuetify.breakpoint.name !== 'xl'">
        <v-col cols="6" class="px-12 pt-0">
          <img :src="require('../../assets/images/glitter-2.png')">
        </v-col>
        <v-col cols="6" >
          <div class="text-right">
            <div class="mr-8">
              <img :src="require('../../assets/images/glitter-2.png')">
            </div>
          <div>
            <img :src="require('../../assets/images/glitter-2.png')" class="mr-12">
            <img :src="require('../../assets/images/ribbon2.png')">
          </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { TokenService } from "../../service/Storage.Service";
import { get, post, put, destroy } from "../../service/Axios";
export default {
  data() {
    return {
      show: false,
      alert: false,
      form: {
        username: "",
        password: ""
      },
      process: {
        run: false
      },
      response: ""
    }
  },
  methods: {
    async save() {
      this.response = "";
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.process.run = true;
        await post(`api/internal/login`, {
          data: {
            email: this.form.username,
            password: this.form.password
          }
        }).then(response => {
          let res = response.data;
          if (res.code === 200) {
            TokenService.saveToken(
              res.data.token,
              JSON.stringify(res.data.user)
            );
            window.location = `/dashboard`;
          } else {
            this.process.run = false;
            this.response = res.msg;
          }
        })
      }
    }
  }
}
</script>

<style>
.v-card > *:first-child:not(.v-btn):not(.v-chip),
.v-card > .v-card__progress + *:not(.v-btn):not(.v-chip) {
  border-top-left-radius: unset !important;
  border-top-right-radius: unset !important;
}
.fcp{
  color: #ff618a !important;
}
.background-login {
  background: url('../../assets/image/login_image.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
  background-position-y: top;
  min-height: 100%;
}
</style>